export default function ChevronBold(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
	return (
		<svg
			width="6"
			height="10"
			viewBox="0 0 6 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M3.45 5L0 1.55L1.05 0.5L5.55 5L1.05 9.5L0 8.45L3.45 5Z" fill="currentColor" />
		</svg>
	)
}
